import { useState } from "react";

import { Form, Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { openSnackbar } from "Redux/Actions/snackbarActions";
import FormControl from "../../MUI_components/FormControl/fomikFormControl";
import { Button, CircularProgress, Typography } from "@mui/material";
import EntryTypeAccount from "Service/Accounts/JournalTypes.service"
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import LedgerTypesService from "Service/Accounts/LedgerTypes.service";


const DoubleEntry = ({ setOpen, code, setSubmitted }) => {
  const dispatch = useDispatch();
  const Validation = yup.object({
    // transactionType: yup.string().required("Transaction type is required"),
    amount: yup.string().required("Amount type is required"),
    // type: yup.string().required("Please get any one"),
  });

  const [initValue, setInitValue] = useState({
    name:"",
    toLedgerType:null,
    toEntryType:null,
    toTransactionMode:null,
    ledgerType:null,
    entryType:null,
    transactionMode:null,

  

  });


  
  const EntryType = [
    { name: 'DEBIT', code: 0 },
    { name: 'CREDIT', code: 1 },
  ]

  const TransactionMode = [
    { name: 'CASH', code: 0 },
    { name: 'CHEQUE', code: 1 },
  ]

  // const { isError, isLoading, data } = useQuery(
  //   [REACT_QUERY_KEYS.CREDIT_AND_DEBIT, code],
  //   () => AcountTransactionsService.getAllTransactionType(),
  //   // {enabled:!!code}
  // )

  // if (isLoading) {
  //   return <Loading/>
  // }
  // if (isError) {
  //   return <ErrorMessage />
  // }


  const handleSubmit = async (values) => {
    console.log(values);
    try {
      if (code)
        await EntryTypeAccount.edit(values, code);
      else
        await EntryTypeAccount.create(values);
      setSubmitted((prev) => !prev);
      setOpen(false);
      dispatch(
        openSnackbar(
          true,
          "success",
          `Enrty Type Accounts ${code ? "updated" : "created"} successfully`
        )
      );
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };

  return (
    <>

      <Formik
        initialValues={initValue}
        //validationSchema={Validation}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form autoComplete="off">

            <div className="row mt">
            <div className="col-12">
                <FormControl
                  control="input"
                  name="name"
                  label="Transection"
                />
              </div>
            </div>

            <div className="row mt">
                <div className="col-3" style={{textAlign:'center',marginTop:15}}>
                <Typography component="p" variant="subtitle1">
                    {COLUMNS_NAME.FROM}
                </Typography>
                </div> 
              <div className="col-3">
              <FormControl
                  control="asynchronousAutoComplete"
                  name="ledgerType"
                  label="Ledger Type"
                  Service={LedgerTypesService}
                  getOptionLabel={(option) =>
                    option.name + "-" + option.code 
                   
                  }
                />
              </div>
              <div className="col-3">
                <FormControl
                  control="autoComplete"
                  name="entryType"
                  label="Entry Type"
                  getOptionLabel={(option) =>
                    option.name
                  }
                  options={EntryType}
                />
              </div>
              <div className="col-3">
                <FormControl
                  control="autoComplete"
                  name="transactionMode"
                  label="Transection Mode"
                  getOptionLabel={(option) =>
                    option.name
                  }
                  options={TransactionMode}
                />
              </div>
            </div>

            <div className="row mt">
            <div className="col-3" style={{textAlign:'center',marginTop:15}}>
            <Typography component="p" variant="subtitle1">
                {COLUMNS_NAME.TO}

            </Typography>
            </div>
              <div className="col-3">
              <FormControl
                  control="asynchronousAutoComplete"
                  name="toLedgerType"
                  label="Ledger Type"
                  Service={LedgerTypesService}
                  getOptionLabel={(option) =>
                    option.name + "-" + option.code 
                   
                  }
                />
              </div>
              <div className="col-3">
                <FormControl
                  control="autoComplete"
                  name="toEntryType"
                  label="Entry Type"
                  getOptionLabel={(option) =>
                    option.name
                  }
                  options={EntryType}
                />
              </div>
              <div className="col-3">
                <FormControl
                  control="autoComplete"
                  name="toTransactionMode"
                  label="Transaction Mode"
                  getOptionLabel={(option) =>
                    option.name
                  }
                  options={TransactionMode}
                />
              </div>
            </div>
            <div className="row flex-end mb">
              <Button

                type="submit"
                style={{ marginRight: 5 }}
                variant="contained"
                color="primary"
                //disabled={isSubmitting}
                startIcon={
                  isSubmitting && (
                    <CircularProgress color="inherit" size={20} />
                  )
                }

              >
                {code ? "Update" : "Save"}
              </Button>
              <Button
                onClick={() => setOpen(false)}
                variant="contained"
                color="secondary"
              >
                Cancel
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default DoubleEntry;
